export default "__VITE_ASSET__B7Py1wkD__"